import { FeatureCard } from "../components/FeatureCard";
import { SectionHeader } from "../components/SectionHeader";
import type { LandingContent } from "../content/types";

type FeatureOverviewSectionProps = {
  content: LandingContent["overview"];
};

export function FeatureOverviewSection({ content }: FeatureOverviewSectionProps) {
  return (
    <section className="section-pad" id="features">
      <div className="site-container">
        <SectionHeader title={content.title} subtitle={content.subtitle} />
        <div className="feature-grid">
          {content.features.map((feature) => (
            <FeatureCard key={feature.title} title={feature.title} body={feature.body} badge={feature.badge} />
          ))}
        </div>
      </div>
    </section>
  );
}
